import { connect } from 'react-redux';
import translate from '../../../../classes/lang.js';
import * as Jsx from './poll_create.jsx'
const { rxaget } = global.rootRequire('classes/ulti')
const RxComponent = global.rootRequire('components/shares/rxComponent').default
const chatDB = global.rootRequire('classes/indexedDB').default
const {changePollsFunc } = global.rootRequire('redux')
class CreatePollComp extends RxComponent {
  constructor(props, context) {
    super(props, context, Jsx)
    this.state = {
      pollQuestion:'',
      pollAnswers:[{'answer': '', 'order' : 0},{'answer': '', 'order' : 1}],
      pollCount:0,
      group : rxaget(this.props, 'rxgroup.group', {}),
      pinStatus:false,
      flagActiveBtn:false
    }
    this.token = global.rxu.get(this.props, 'netaauth.user.token')
    this.timeout = null

  }
  addPollItem(){
    let pollAnswers = this.sortPoll(this.state.pollAnswers)
    let pollSize = pollAnswers.length || 0
    if(pollSize < 10){
      let lastAnswer = pollAnswers[pollSize-1] 
      let order = lastAnswer?.order +1 || 0
      let answerTmp = {'answer': '', 'order' : order}
      pollAnswers.push(answerTmp)
      this.setState({pollAnswers:pollAnswers},()=>{
        let divId = 'zpopupPool-list'
        this.scrollDownList(divId)
      })
    }
  }
  
  sortPoll(pollAnswers){
    pollAnswers = pollAnswers.sort((a,b)=>a.order<b.order)
    return pollAnswers
  }
  removePollItem(ele){
    let pollAnswers = this.state.pollAnswers
    if(pollAnswers.length >= 3){
      const index = pollAnswers.indexOf(ele);
      pollAnswers.splice(index, 1);
      this.setState({pollAnswers:pollAnswers},()=>{
        this.checkPollVal()
      })
    }
  }
  onChangePinPoll(){
    let pinStatus = !this.state.pinStatus
    this.setState({pinStatus:pinStatus})
  }
  onchangeQuestion(e){
    let value = e.target.value
    this.setState({pollQuestion:value},()=>{
      this.checkPollVal()
    })
    
  }
  scrollDownList(id) {
    const chatListDiv = document.getElementById(id)
    if (chatListDiv) {
      chatListDiv.scrollTop = chatListDiv.scrollHeight
    }
  }
  onchangeAnswers(e,ele){
    let value = e.target.value
    let pollAnswers = this.sortPoll(this.state.pollAnswers)
    let params={
        'answer': value,
        'order' : ele.order
      }
    const index = pollAnswers.findIndex(el => el.order ===ele.order);
    pollAnswers[index] = params
    this.setState({pollAnswers:pollAnswers},()=>{
      this.checkPollVal()
    })
    

  }
  checkPollVal(){
    let pollAnswers = this.state.pollAnswers
    let pollQuestion =  this.state.pollQuestion
    let flagActiveBtn = this.state.flagActiveBtn
    let validateAnswers = pollAnswers.filter((o)=>{return(o.answer.length > 0)})
    if(validateAnswers.length >= 2 && pollQuestion.length > 0 && !flagActiveBtn){
      this.setState({flagActiveBtn:true})
    }
    if(flagActiveBtn && (validateAnswers.length < 2 || pollQuestion.length === 0)){
      this.setState({flagActiveBtn:false})
    }
  }

  async addPollInfo(pollInfo,group_id){
    let polls =  await chatDB.polls.get({ group_id: group_id })
    let pollsArr = polls.data
    pollsArr.push(pollInfo)
    let params = {
      group_id:group_id,
      data:pollsArr,
    }

    await chatDB.polls.put(params,group_id.toString()).then(()=>{
      this.props.changePollsFunc()
    })
  }

  async createPoll(){
    let group_id = Number(this.state.group.group_id)
    let pollAnswers = this.state.pollAnswers
    let validateAnswers = pollAnswers.filter((o)=>{return(o.answer.length > 0)})
    let pollQuestion = this.state.pollQuestion
    let pinStatus = this.state.pinStatus
    
    let polls = await chatDB.polls.get({group_id:group_id.toString()})
    if(polls && polls.data && polls.data.length >= 5){
      alert(translate('You can only create up to 5 poll'))
    }else{
      let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8',  'TC-Token': this.token }
      let params = {
        group_id:group_id.toString(),
        question:pollQuestion,
        answers:validateAnswers
  
      }
      fetch(global.rxu.get(global.rxu.config, 'api_poll_create'), {
        method: 'POST',
        body: JSON.stringify(params),
        headers: headers 
      })
      .then((res) => { return res.json() })
      .then(async(json) => {
        let pollInfo = {...json}
        let pollsArr
        if(!polls){
           pollsArr = []
        }else{
          pollsArr = [...polls.data]
        }
        pollsArr.push(pollInfo)
        let params = {
          group_id:group_id.toString(),
          data:pollsArr,
        }
    
        await chatDB.polls.put(params,group_id.toString()).then(()=>{
          this.props.changePollsFunc()
        })

        this.props.sendPollMess(pollInfo,pinStatus, 1)
      }).catch(er => console.log(er))
    }

    this.props.closePollPopup() 
  }

  render() {
    return this.renderComponent()
  }
}

const mapStateToProps = (state, ownProps) => ({
  netaauth: state.netaauth,
  rxgroup: state.rxgroup,
})

const mapDispatchToProps = {
  changePollsFunc
}

const CreatePollComp_ = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreatePollComp)

export default CreatePollComp_